/**
 * Facts about a person that the People directory states rather than infers.
 *
 * Kept out of the screen so the date arithmetic can be tested on its own — the
 * component imports a tree Jest cannot load, and these are the parts most
 * likely to be quietly wrong at a boundary.
 */

/**
 * Both sides reduced to a calendar day in UTC.
 *
 * These are day questions, not moment questions: somebody joining "today" has
 * joined whatever the clock says, and comparing raw timestamps makes a start
 * date recorded at midnight look like it is still in the future for the rest of
 * the day. Dates arrive as UTC-midnight ISO strings, so the day is taken from
 * the string rather than through a local-time conversion that would shift it
 * west of Greenwich.
 */
const startOfToday = () => {
  const n = new Date();
  return Date.UTC(n.getFullYear(), n.getMonth(), n.getDate());
};

const dayValue = (d) => {
  if (!d) return NaN;
  const t = new Date(String(d).slice(0, 10));
  return Number.isNaN(t.getTime()) ? NaN : t.getTime();
};

/**
 * Someone whose first day has not arrived.
 *
 * Strictly after today: a person starting this morning has started, and the
 * card must say "Joined", not "Starts".
 */
export const startsLater = (e) => {
  const join = dayValue(e?.joiningDate);
  return !Number.isNaN(join) && join > startOfToday();
};

/** Serving notice: a last working day that has not passed yet. */
export const onNotice = (e) => {
  const exit = dayValue(e?.lastWorkingDay);
  return !Number.isNaN(exit) && exit >= startOfToday();
};

/** Arriving before this calendar month is out. */
export const joiningThisMonth = (e) => {
  const join = dayValue(e?.joiningDate);
  if (Number.isNaN(join) || join <= startOfToday()) return false;
  const n = new Date();
  // The last day of this month, as a day rather than an instant.
  return join <= Date.UTC(n.getFullYear(), n.getMonth() + 1, 0);
};
